import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import FiltersButton from 'components/Filters/FiltersButton/FiltersButton';
import { getFilterCount } from 'store/search/searchSelectors';

const SearchFiltersButton = ({ onClick, label }) => {
  const count = useSelector(getFilterCount);

  return <FiltersButton onClick={onClick} label={label} count={count} />;
};

SearchFiltersButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
};

SearchFiltersButton.defaultProps = {
  label: 'Filters',
};
export default SearchFiltersButton;
